//
// Use in callbacks etc... to know wether the originating item
// is still mounted when callback comes back.
//
// Use as:
//
// const isMounted = useIsMounted();
// ...
// if (isMounted.current) { ... }
//
import {
  useRef,
  useEffect,
} from 'react';

import { logDev } from '../../utils';

const useIsMounted = (logLabel) => {
  const isMounted = useRef();

  useEffect(
    () => {
      isMounted.current = Math.floor((Math.random() * 10000) + 1); // NOSONAR cosmetic UI value, not security-sensitive

      if (logLabel) logDev(`useIsMounted ${logLabel} mounted id=${isMounted.current}`);

      return () => {
        if (logLabel) logDev(`useIsMounted ${logLabel} un-mounted id=${isMounted.current}`);
        isMounted.current = false;
      };
    },
    [logLabel],
  );

  return isMounted;
};

export default useIsMounted;
